module.exports = __webpack_public_path__ + "static/media/googleplay-store.b9391c57.svgz";